import { Button, Icon, Input, Typography, handleValid } from 'components'
import {
	GroupComponentsLinkProps,
	Icons,
	LinkItem,
	TabMyOrganizationItem,
	TypographyTypes
} from 'interfaces'
import React, { useEffect } from 'react'
import { Controller, Path, useFieldArray, useForm } from 'react-hook-form'
import { configGenaral } from 'utils'
import {
	PropsComponentsMyOrganization,
	onChangeFieldProps,
	typeFieldLink
} from './interfaceSlide.type'

const GroupComponents: React.FC<
	GroupComponentsLinkProps & onChangeFieldProps
> = ({
	register,
	index,
	deleteComponent,
	watch,
	setValue,
	onChangeField,
	errorCustom
}): JSX.Element => {
	const rules = {
		title: {
			required: { value: true, message: 'Is required' }
		},
		url: {
			required: { value: true, message: 'Is required' },
			maxLength: {
				value: 512,
				message: 'URL too large. Maximum 512 characters.'
			},
			pattern: {
				value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
				message: 'Please enter a valid url'
			}
		}
	}

	const watchTitle = watch?.(`links.${index}.text_link`)
	const watchUrl = watch?.(`links.${index}.url`)

	return (
		<div className="flex flex-col w-full gap-6 mb-6">
			<Input
				name={`links.${index}.text_link`}
				title="Title"
				register={register}
				rules={rules.title}
				error={errorCustom?.text_link}
				borderFull
				limit
				cantLimit={configGenaral.maxTitleLength}
				watchValue={watchTitle}
				setValueInput={setValue}
				onChangeCustom={e => {
					const { value } = e.target
					onChangeField({
						text_link: value,
						url: watchUrl
					})
				}}
			/>
			<Input
				name={`links.${index}.url`}
				title="URL"
				register={register}
				rules={rules.url}
				error={errorCustom?.url}
				borderFull
				setValueInput={setValue}
				onChangeCustom={e => {
					const { value } = e.target
					onChangeField({
						text_link: watchTitle,
						url: value
					})
				}}
			/>
			{index > 0 && (
				<div
					aria-hidden="true"
					className=" flex gap-2 cursor-pointer"
					onClick={() => deleteComponent(index)}
				>
					<Icon
						src={Icons.delete}
						className="w-[16px] h-[18px] text-gray-3"
						fillPath
					/>
					<Typography
						title="Remove Link"
						className="text-gray-3"
						fontLeading="15/18"
						type={TypographyTypes.p}
					/>
				</div>
			)}
		</div>
	)
}

export const SlideLink: React.FC<PropsComponentsMyOrganization> = ({
	setErrorForm,
	pos,
	watch: watchParent,
	setValue: setValueForm,
	setFieldError,
	name
}): JSX.Element => {
	const data = watchParent(
		`${name}.${pos}.component_value` as Path<{ tabs: TabMyOrganizationItem[] }>
	) as {
		links?: {
			text_link: string
			url: string
		}[]
	}

	const {
		control,
		register,
		watch,
		setValue,
		formState: { errors, isValid }
	} = useForm<typeFieldLink>({
		mode: 'onChange',
		defaultValues: {
			links: data?.links ?? [
				{
					text_link: '',
					url: ''
				}
			]
		}
	})

	const { fields, remove, append } = useFieldArray({
		control,
		name: 'links'
	})

	const nameType = `link-${name}-${pos}`

	useEffect(() => {
		handleValid(nameType, isValid, setFieldError)
		setErrorForm?.(!isValid)
	}, [isValid])

	return (
		<div className="flex flex-col justify-between overflow-hidden p-2">
			<div className="flex flex-col w-full overflow-y-auto  max-h-[calc(100vh-130px)] ">
				<div className="mr-2">
					{fields.map((component, index) => {
						return (
							<Controller
								key={`links-${component.id}`}
								control={control}
								name={`links.${index}`}
								render={() => {
									return (
										<GroupComponents
											register={register}
											index={index}
											errors={errors}
											deleteComponent={remove}
											watch={watch}
											setValue={setValue}
											onChangeField={() => {
												const resultData = watch().links?.[index]
												setValueForm(
													`${name}.${pos}.component_value.links.${index}` as Path<{
														tabs: TabMyOrganizationItem[]
													}>,
													resultData as LinkItem
												)
											}}
											errorCustom={errors?.links?.[index]}
										/>
									)
								}}
							/>
						)
					})}
				</div>
				<div className="w-full mt-6">
					<Button
						type="button"
						label="Add"
						small
						onClick={() =>
							append({
								text_link: '',
								url: ''
							})
						}
						iconLeft={Icons.plus}
					/>
				</div>
			</div>
		</div>
	)
}
